import {
  NavLink as MantineNavLink,
  NavLinkProps,
  createPolymorphicComponent,
} from '@mantine/core';
import React from 'react';

export type INavLinkProps = NavLinkProps;

const NavLinkBase = React.forwardRef<HTMLAnchorElement, INavLinkProps>(
  (props, ref) => <MantineNavLink {...props} ref={ref} />,
);
NavLinkBase.displayName = 'NavLink';

/** @registry Design-layer pass-through over Mantine NavLink; import this instead of @mantine/core NavLink outside src/design. Preserves polymorphism (e.g. component={Link}). */
export const NavLink = createPolymorphicComponent<'a', INavLinkProps>(
  NavLinkBase,
);
